/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CognitoDisputeStatus {
	InquiryNeedsResponse = 'InquiryNeedsResponse',
	InquiryUnderReview = 'InquiryUnderReview',
	InquiryClosed = 'InquiryClosed',
	NeedsResponse = 'NeedsResponse',
	UnderReview = 'UnderReview',
	Won = 'Won',
	Lost = 'Lost',
	Prevented = 'Prevented',
}
